const SI_VENDOR_TICKER_ALLOWLIST = [
  'ADBE', 'AMZN', 'APPN', 'COUP', 'CRM', 'CSCO', 'CYBR', 'DAY', 'DCT',
  'DDOG', 'DT', 'GNSYS', 'GOOGL', 'GWRE', 'MDB', 'MSFT', 'NCNO', 'NICE',
  'NOW', 'OKTA', 'ORCL', 'OS', 'OTEX', 'PANW', 'PLAN', 'PLTR', 'PVT-ANTH',
  'PVT-DBRK', 'PVT-OAI', 'SAIL', 'SAP', 'SNOW', 'SPLK', 'TDC', 'TEAM',
  'VEEV', 'WDAY', 'ZS',
];

const SI_VENDOR_TICKERS = (() => {
  const tickers = new Set(SI_VENDOR_TICKER_ALLOWLIST);
  return tickers;
})();

export const hasSiPartnerHiringByTicker = (candidateTicker) => (
  SI_VENDOR_TICKERS.has(String(candidateTicker || '').toUpperCase())
);
